import { render, staticRenderFns } from "./NewPass.vue?vue&type=template&id=4044255a&scoped=true&"
import script from "./NewPass.vue?vue&type=script&lang=js&"
export * from "./NewPass.vue?vue&type=script&lang=js&"
import style0 from "./NewPass.vue?vue&type=style&index=0&id=4044255a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4044255a",
  null
  
)

export default component.exports